/* eslint-disable max-len */
import React from "react"
import BaseSvgIcon from "./Base"

export default (props) => {
  return (
    <BaseSvgIcon viewBox="0 0 24 24" {...props}>
      <path d="M20.3,17c-0.3-0.6-1-1.1-2.2-1.6c-0.4-0.2-0.9-0.4-1.5-0.6c-0.3-0.1-1.6-0.6-1.7-0.6c-0.2-0.1-0.3-1.4-0.1-1.6,c1.1-1.2,1.6-2.8,1.5-4.4c0.1-1-0.2-2-1-2.8C14.6,4.5,13.6,4,12.5,4s-2.1,0.5-2.8,1.3S8.6,7.2,8.8,8.2c-0.2,1.5,0.4,3.1,1.5,4.3,c0.2,0.2,0.1,1.5-0.1,1.6c-0.1,0-1.4,0.5-1.7,0.6c-0.6,0.2-1.1,0.4-1.5,0.6c-1.2,0.5-1.8,1-2.2,1.6C4.3,18.1,4,19.3,4,20.5,C4,20.8,4.2,21,4.5,21h16c0.3,0,0.5-0.2,0.5-0.5C21,19.3,20.7,18.1,20.3,17z M5,20c0.1-0.9,0.3-1.8,0.6-2.6c0.2-0.3,0.7-0.7,1.7-1.1,c0.4-0.2,0.8-0.4,1.4-0.6c0.3-0.1,1.7-0.6,1.7-0.6c1-0.4,1.1-2.6,0.5-3.2c-0.9-1-1.3-2.3-1.2-3.6c0-1,0.2-1.7,0.7-2.3,c0.6-0.6,1.3-1,2.1-1s1.5,0.4,2,1s0.8,1.4,0.7,2.2c0.1,1.4-0.3,2.7-1.2,3.7c-0.6,0.7-0.5,2.8,0.5,3.2c0.1,0,1.4,0.5,1.7,0.6,c0.6,0.2,1.1,0.4,1.4,0.6c1,0.4,1.5,0.8,1.7,1.1c0.3,0.8,0.6,1.7,0.6,2.6H5z" />
    </BaseSvgIcon>
  )
}
